<template lang="pug">
  .form
    .form__elem(
      v-for="item in fields"
      v-bind:class="{ 'form__elem_short' : item.short }"
    )
      .form-elem.form-elem_horizontal(
        v-if="item.type === 'text' || item.type === 'date'"
      )
        .form-elem__title {{ item.title }}
        .form-elem__body
          .input.input_full(
            v-if="item.type === 'date'"
            v-simple-date="requestData[item.key]"
          ) {{ requestData[item.key] }}
          .input.input_full(
            v-else
          ) {{ requestData[item.key] }}
      .form-elem.form-elem_horizontal(
        v-else-if="item.type === 'file'"
      )
        .form-elem__title {{ item.title }}
        .form-elem__body
          .attach-file
            .attach-file__empty(
              v-if="requestData[item.files].length === 0"
            ) Нет файлов
            .attach-file__list(
              v-if="requestData[item.files].length > 0"
            )
              .attach-file__item(
                v-for="file in requestData[item.files]"
              )
                .attached-file
                  a.button(
                  target="_blank"
                  :href="file.file"
                  )
                    .button__icon
                      img(src="@/assets/images/icons/doc.svg")
                    .button__text {{ file.name }}
          .form-elem__description(
            v-if="item.description && requestData[item.files].length > 0"
          ) {{ item.description }}
</template>
<script>
export default {
  name: "Info",
  props: ["fields", "requestData"],
  mounted() {}
};
</script>
